import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import { Modal } from 'antd';
import { withRouter } from 'react-router';
import { withApollo } from 'react-apollo';
import PubSub from '../src/services/PubSub';
import { isArray, size, get, orderBy, map, split, flatten, isEmpty, filter, includes, head, groupBy, pull } from 'lodash';
import moment from 'moment';
import { OrdersTable } from '../src/components/sections/Orders';
import { withNavigation, withFirebase } from '../src/hoc';
import { GET_CARRIERS, GET_ORDERS, GET_SALES_CHANNELS, GET_CATEGORIES_PEDIDO } from '../src/queries';
import { Pagination, HasPermissions, NotFound, Loading, Main, Container, FlexContainer, If, MobilePageTitle, Button, MobileWrapper, TableCount, Column, Row } from '../src/components/common';
import LeftFilters from '../src/components/sections/Orders/LeftFilters';
import { Query, ModuleAccessLogger } from '../src/components/graphql';
import { MediaListener } from '../src/components/utils';
import { _get } from '../src/utils/misc';
import TopFilters from '../src/components/sections/Orders/TopFilters';
import RightHeader from '../src/components/sections/Orders/RightHeader';
import DrawerReschedulingMassive from '../src/components/sections/Orders/DrawerReschedulingMassive';
import esDictionary from '../src/i18n/es';
import {  orderTypeOptions } from '../src/utils/misc';

const Orders = ({ session, firebasePerformance, location, history, client }) => {
    // Sales channels got from user session
    const sessionSalesChannel = orderBy(map(get(session, 'salesChannels'), ({ name, store, id, kind }) => ({ label: `${store} - ${name}`, value: id, kind })), ['label'], ['asc']);
    const getSessionSalesChannelById = map(sessionSalesChannel, ({ value }) => value);

    // Filtros que vienen desde gestion sala y resumen de tiendas
    const [searchParams] = useState(new URLSearchParams(location.search));
    const salesChannelParams = searchParams.has('salesChannel') ? split(searchParams.get('salesChannel'), ',') : '';
    const selectedSlaParams = searchParams.has('selectedSla') ? split(searchParams.get('selectedSla'), ',') : '';
    const statusParams = searchParams.has('status') ? split(searchParams.get('status'), ',') : '';
    const rangeParams = searchParams.has('range') ? split(searchParams.get('range'), ',') : '';
    const nameCarrierParams = searchParams.has('nameCarrier') ? searchParams.get('nameCarrier') : '';
    const companyGroupParams = searchParams.has('companyGroup') ? searchParams.get('companyGroup') : '';
    const atrasadoFromUrl = searchParams.get('atrasado') === 'true';
    const noDataParams = ['', 'null', 'undefined'];

    let params = {
        status: includes(noDataParams, statusParams[0]) ? null : statusParams,
        selectedSla: includes(noDataParams, selectedSlaParams[0]) ? null : selectedSlaParams,
        salesChannel: includes(noDataParams, salesChannelParams[0]) ? null : map(salesChannelParams, (salesChannel) => { return { value: salesChannel }; }),
        range: includes(noDataParams, rangeParams[0]) ? null : rangeParams,
        nameCarrier: includes(noDataParams, nameCarrierParams[0]) ? null : nameCarrierParams,
        companyGroup: includes(noDataParams, companyGroupParams[0]) ? null : companyGroupParams,
        atrasado: atrasadoFromUrl
    };
    // Firebase: Instance performance monitoring service
    const [traceOrdersInitialLoad] = useState(firebasePerformance.trace('ORDERS_INITIAL_LOAD'));
    const [traceOrdersAction, setTraceOrdersAction] = useState({});

    useEffect(() => {
        // Firebase: Starts the timing for the trace instance
        traceOrdersInitialLoad.start();
    }, [traceOrdersInitialLoad]);

    useEffect(() => {
        // Firebase: Starts the timing for the trace instance
        get(traceOrdersAction, 'state') === 1 && traceOrdersAction.start();
    }, [traceOrdersAction]);

    const [allSalesChannels, setAllSalesChannels] = useState({});
    const [allCategory, setallCategory] = useState({});

    // This useEffect makes that page autorefresh if user session data has changed
    const [useEffectCount, setUseEffectCount] = useState(0);
    useEffect(() => {
        setUseEffectCount(useEffectCount + 1);
        (!params.range || useEffectCount > 1) && onReset();
    }, [session]);

    useEffect(() => {
        const getAllSalesChannels = async () => {
            const data = await client.query({
                query: GET_SALES_CHANNELS,
                variables: {},
                fetchPolicy: 'network-only'
            });

            const allSalesChannelsById = map(get(data, 'data.salesChannels'), ({ id }) => {
                return { value: id };
            });

            setAllSalesChannels(allSalesChannelsById);
        };

        const getAllCategory = async () => {
            const getCategory = await client.query({
                query: GET_CATEGORIES_PEDIDO,
                variables: {},
                fetchPolicy: 'network-only'
            });

            setallCategory(getCategory.data);
        };
      
        getAllCategory()
        getAllSalesChannels();
        setLoadingReportBtn(true);
    }, []);

    // Both methods format date ranges
    const formatRanges = (value, filter) => {
        return {
            init: `${value[0].format('YYYY-MM-DD')} 00:00:00`,
            end: `${value[1].format('YYYY-MM-DD')} 23:59:59`,
            filter
        };
    };
    const formatDateRangeFilter = ({ value = [moment(), moment()], name }) => {
        switch (name) {
        case 'creationDate':
            return formatRanges(value, name);
        default:
            return formatRanges(value, 'detail.shippingData.logisticsInfo.shippingETA.init');
        }
    };

    // Determines initial state to filter checkboxes
    const checkboxesReducer = () => {
        if (params.range) return { shippingETA: true, creationDate: false };
        return { shippingETA: true, creationDate: false };
    };

    const getFilterRange = () => {
        let range = [
            {
                filter: 'detail.shippingData.logisticsInfo.shippingETA.init',
                init: moment(params.range[0]).format('YYYY-MM-DD HH:mm:ss'),
                end: moment(params.range[1]).format('YYYY-MM-DD HH:mm:ss')
            }
        ];
        return searchParams.get('fromRoomManagement') === 'true'
            ? [ ...range, {
                filter: 'detail.shippingData.logisticsInfo.shippingETA.end',
                init: moment(params.range[0]).format('YYYY-MM-DD HH:mm:ss'),
                end: moment(params.range[1]).format('YYYY-MM-DD HH:mm:ss')
            }]
            : range;
    };

    const [datePickerCheckboxes, setDatePickerCheckboxes] = useState(checkboxesReducer());
    const [creationDate, setCreationDate] = useState(formatDateRangeFilter({ name: 'creationDate' }));
    const [shippingETA, setShippingETA] = useState(formatDateRangeFilter({ name: 'shippingETA' }));
    const [salesChannel, setSalesChannel] = useState(getSessionSalesChannelById);
    const [category, setCategory] = useState(null);
    const [selectedSla, setSelectedSla] = useState(null);
    const [status, setStatus] = useState(null);
    const [orderType, setOrderType] = useState(null);
    const [shopper, setShopper] = useState(null);
    const [orderId, setOrderId] = useState(null);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [orderData, setOrderData] = useState({});
    const [lastName, setLastName] = useState(null);
    const [email, setEmail] = useState(null);
    const [document, setDocument] = useState(null);
    const [reseting, setReseting] = useState(false);
    const [pageSize, setPageSize] = useState(100);
    const [timestamp, setTimestamp] = useState(new Date().toISOString());
    const [currentPage, setCurrentPage] = useState(1);
    const [selectAll, setSelectAll] = useState(true);
    const [ordersCount, setOrdersCount] = useState(0);
    const [loadingReportBtn, setLoadingReportBtn] = useState(false);
    const [resetTop, setResetTop] = useState(false);
    const [leftFiltersInitialized, setLeftFiltersInitialized] = useState(false);
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const [refreshRightHeader, setRefreshRightHeader] = useState(false);
    const [atrasado, setAtrasado] = useState(params.atrasado);
    // On change this hook values, the query will be refetched
    const [queryVariables, setQueryVariables] = useState({
        creationDate: formatDateRangeFilter({ name: 'creationDate' }),
        status: params.status ? [{ value: params.status }] : null,
        selectedSla: params.selectedSla ? [{ value: params.selectedSla }] : null,
        salesChannel: params.salesChannel,
        dateRanges: params.range
            ? getFilterRange()
            : formatDateRangeFilter({ name: 'creationDate' }),
        courierName: params.nameCarrier,
        category: null,
        atrasado: params.atrasado
    });

    // Rescheduling Massive
    const [massiveAction, setMassiveAction] = useState({});
    const [opened, setOpened] = useState(false);

    useEffect(() => {
        PubSub.dispatch('SET_RIGHT_HEADER', () => (<RightHeader
            ordersCount={ordersCount}
            loadingBtnExport={loadingReportBtn}
            filteredVariables={filteredVariables}
            getSessionSalesChannelById={getSessionSalesChannelById}
            variables={variables}
            action={massiveAction}
            setAction={setMassiveAction}
            setOpened={setOpened}
            selectedOrders={selectedOrders}
            orderData={orderData}
            session={session}
            setRefreshRightHeader={setRefreshRightHeader}
            refreshRightHeader={refreshRightHeader}
        />));
        return () => {
            PubSub.dispatch('SET_RIGHT_HEADER', () => '');
            PubSub.dispatch('SET_CENTER_HEADER', () => '');
        };
    }, [ ordersCount, loadingReportBtn, selectedOrders, massiveAction, refreshRightHeader ]);

    const cleanURLSearchParams = () => {
        searchParams.delete('salesChannel');
        searchParams.delete('selectedSla');
        searchParams.delete('status');
        searchParams.delete('range');
        searchParams.delete('fromRoomManagement');
        searchParams.delete('companyGroup');
        searchParams.delete('courierName');
        searchParams.delete('atrasado');
        searchParams.delete('nameCarrier');
    };

    const onReset = () => {
        // Limpia filtros de URL al redireccionar
        history.push('/orders');

        cleanURLSearchParams();
        setReseting(true);
        setDatePickerCheckboxes({ shippingETA: true, creationDate: false });
        setCreationDate(formatDateRangeFilter({ name: 'creationDate' }));
        setShippingETA(formatDateRangeFilter({ name: 'shippingETA' }));
        setSalesChannel(getSessionSalesChannelById);
        setCategory(null);
        setSelectedSla(null);
        setStatus(null);
        setAtrasado(false);
        setShopper(null);
        setOrderId(null);
        setLastName(null);
        setEmail(null);
        setDocument(null);
        setPageSize(100);
        setCurrentPage(1);
        setTimeout(() => {
            setQueryVariables({ dateRanges: formatDateRangeFilter({ name: 'shippingETA' }), atrasado: false });
            setReseting(false);
        }, 20);
    };

    const onSubmit = () => {
        setLoadingReportBtn(true);
        // Limpia filtros de URL al redireccionar
        history.push('/orders');
        cleanURLSearchParams();

        // Firebase: Instance performance monitoring service
        setTraceOrdersAction(firebasePerformance.trace('ORDERS_ACTION'));
        setPageSize(100);
        setCurrentPage(1);
        setTimestamp(new Date().toISOString());

        if (leftFiltersInitialized) {
            let range = [];
            if (get(datePickerCheckboxes, 'shippingETA')) range = [formatDateRangeFilter({ value: shippingETA, name: 'shippingETA' })];
            if (get(datePickerCheckboxes, 'creationDate')) range = [...range, formatDateRangeFilter({ value: creationDate, name: 'creationDate' })];
            return setQueryVariables({
                dateRanges: !isEmpty(range) ? range : formatDateRangeFilter({ name: 'creationDate' }),
                salesChannel: size(orderId) > 0 || size(lastName) > 0 || size(document) > 0 || size(email) > 0 ? allSalesChannels : salesChannel,
                selectedSla,
                status,
                orderType,
                orderId,
                lastName,
                email,
                document,
                shopper: selectAll ? null : isArray(shopper) ? map(shopper, 'value') : get(shopper, 'value'),
                category,
                atrasado
            });
        }

        setQueryVariables({
            orderId,
            lastName,
            email,
            document,
            salesChannel: size(orderId) > 0 || size(lastName) > 0 || size(document) > 0 || size(email) > 0 ? allSalesChannels : [],
            atrasado
        });
    };

    const formatFieldValue = (field) => {
        const value = get(queryVariables, field, null);
        if (isEmpty(value) && field === 'salesChannel') return getSessionSalesChannelById;
        if (isEmpty(value)) return null;
        return flatten(map(value, ({ value }) => value));
    };

    const formatCategoryValue = () => {

        const value = get(queryVariables, 'category', null);
        if (isEmpty(value)) return null;
        return  flatten(map(value, ({ value }) => String(value)));
    };

    const formatStatusValue = () => {
        const value = get(queryVariables, 'status', null);
        if (isEmpty(value) || size(value) === 14) return null;
        return flatten(map(value, ({ value }) => split(value, '-')));
    };

    const onChangeDatePickerCheckbox = (value, index) => {
        const shippingETAStatus = get(datePickerCheckboxes, 'shippingETA');
        const creationDateStatus = get(datePickerCheckboxes, 'creationDate');
        switch (index) {
        case 'shippingETA':
            if (!creationDateStatus) return;
            return setDatePickerCheckboxes({
                shippingETA: value,
                creationDate: creationDateStatus
            });
        default:
            if (!shippingETAStatus) return;
            return setDatePickerCheckboxes({
                shippingETA: shippingETAStatus,
                creationDate: value
            });
        }
    };


    const formatOrderType = (typeSearch) => {
        const orderTypes = get(queryVariables, 'orderType', []);
        if (!Array.isArray(orderTypes) || orderTypes.length === 0) return null;

        const selectedValues = new Set(orderTypes.map(o => o.value));
      
        // Si contiene todos los tipos
        if (selectedValues.size === orderTypeOptions.length) return null;
      
        // Si contiene solo 'monopicking'
        if (selectedValues.size === 1 && selectedValues.has('monopicking')) return 'false';
      
        return selectedValues.has(typeSearch) ? 'true' : null;
      };

    const variables = {
        size: pageSize,
        range: size(get(queryVariables, 'orderId')) > 0 || size(get(queryVariables, 'lastName')) > 0 || size(get(queryVariables, 'document')) > 0 || size(get(queryVariables, 'email')) > 0 ? [] : get(queryVariables, 'dateRanges', formatDateRangeFilter({ name: 'shippingETA' })),
        filters: [
            {
                field: 'salesChannelId',
                value: formatFieldValue('salesChannel')
            },
            {
                field: 'logisticsInfo-selectedSla',
                value: formatFieldValue('selectedSla')
            },
            {
                field: 'status',
                value: formatStatusValue()
            },
            {
                field: 'idUser',
                value: get(queryVariables, 'shopper', null)
            },
            {
                field: 'id',
                value: get(queryVariables, 'orderId', null)
            },
            {
                field: 'customer-lastName',
                value: get(queryVariables, 'lastName', null)
            },
            {
                field: 'customer-email',
                value: get(queryVariables, 'email', null)
            },
            {
                field: 'customer-document',
                value: get(queryVariables, 'document', null)
            },
            {
                field: 'courierName',
                value: get(queryVariables, 'courierName', null)
            },
            {
                field: 'categoriesIds',
                value: formatCategoryValue()
            },
            {
                field: 'bipicking',
                value: formatOrderType('bipicking')
            },
            {
                field: 'atrasado',
                value: get(queryVariables, 'atrasado') ? ['true'] : null
            },
        ],
        fromRoomManagement: searchParams.get('fromRoomManagement') === 'true',
        page: currentPage,
        timestamp
    };

    const filteredVariables = (input) => {
        const { filters, ...more } = input;
        const cleanNullFields = filter(filters, ({ value }) => {
            return value === false || value === true || !isEmpty(value)
        });

        return { ...more, filters: cleanNullFields };
    };

    const handleSetStateTopFilter = (orderId, lastName, email, document, isCleaningFilter) => {
        setOrderId(orderId);
        setLastName(lastName);
        setEmail(email);
        setDocument(document);

        !isCleaningFilter &&
            setQueryVariables((queryVariablesPreview) => {
                return {
                    ...queryVariablesPreview,
                    orderId,
                    lastName,
                    email,
                    document,
                    salesChannel: size(orderId) > 0 || size(lastName) > 0 || size(document) > 0 || size(email) > 0 ? allSalesChannels : []
                };
            });
    };

    const onSelectOrderMassiveAction = (selectedRows, selected, record = {}) => {
        const modalConfig = {
            title: 'Reprogramación masiva',
            content: 'Seleccione órdenes de un solo tipo de envío y presiones ejecutar'
        };
        const shippingTypeGrouped = groupBy(selectedRows, 'logisticsInfo.selectedSla');

        if (size(shippingTypeGrouped) > 1) {
            Modal.warning(modalConfig);
            selected && setSelectedOrders(pull(selectedOrders, get(record, 'id')));
        } else {
            Modal.warning().destroy();
            setSelectedOrders(map(selectedRows, 'id'));
        }

        setOrderData(size(selectedRows) > 0 ? head(selectedRows) : selectedRows);
    };

    const matchCarriersAndOrders = (orders, carriers) => {
        return map(orders, (order) => {
            const carrier = head(filter(carriers, (carrier) => {
                return get(order, 'courierName') === get(carrier, 'carrier');
            }));

            return { ...order, category: get(carrier, 'category'), time: get(carrier, 'time') };
        });
    };

    return (
        <HasPermissions
            to={['orders-page:view']}
            otherwise={<NotFound firstTextLine='Página no encontrada' style={{ minHeight: '90vh' }} />}
        >
            <ModuleAccessLogger module='Pedidos' />
            <Container direction='row' withFooter={false}>
                <HasPermissions to={['orders-page:filter&search']}>
                    <LeftFilters
                        userSalesChannel={getSessionSalesChannelById}
                        defaultShippingETA={params.range ? [moment(params.range[0], 'YYYY-MM-DD HH:mm:ss'), moment(params.range[1], 'YYYY-MM-DD HH:mm:ss')] : [moment(), moment()]}
                        defaultSla={params.selectedSla}
                        defaultStatus={params.status}
                        defaultCompanyGroup={params.companyGroup}
                        defaultSalesChannel={params.salesChannel || sessionSalesChannel}
                        sessionSalesChannel={sessionSalesChannel}
                        salesChannel={salesChannel}
                        allCategoryOptions={allCategory}
                        category={category}
                        datePickerCheckboxes={datePickerCheckboxes}
                        onChangeDatePickerCheckbox={(value, index) => onChangeDatePickerCheckbox(value, index)}
                        onChangeCreationDate={value => {
                            if (!leftFiltersInitialized) setLeftFiltersInitialized(true);
                            setCreationDate(value);
                        }}
                        onChangeShippingETA={value => setShippingETA(value)}
                        onChangeSalesChannel={setSalesChannel}
                        onChangeCategory={value => setCategory(value) }
                        selectedSla={selectedSla}
                        onChangeSelectedSla={value => setSelectedSla(value)}
                        status={status}
                        shopper={shopper}
                        onChangeShopper={value => setShopper(value)}
                        onChangeStatus={value => setStatus(value)}
                        defaultAtrasado={atrasado}
                        onChangeAtrasado={setAtrasado}
                        onChangeOrderType={value => {
                            setOrderType(value)
                        }}
                        orderType={orderType}
                        reseting={reseting}
                        onReset={onReset}
                        onSubmit={onSubmit}
                        onChangeSelectAll={value => setSelectAll(value)}
                    />
                </HasPermissions>
                <Main withFooter>
                    <MobilePageTitle text='Pedidos' />
                    <FlexContainer shrink={0} grow={1} style={{ padding: '5px 25px 0px' }} direction='column'>
                        <HasPermissions to={['orders-page:filter&search']} >
                            <MediaListener values={['18%', '100%', '100%']}>
                                {({ currentValue }) => (
                                    <TopFilters
                                        currentValue={currentValue}
                                        handleSetStateTopFilter={handleSetStateTopFilter}
                                        reseting={reseting}
                                        onSubmit={onSubmit}
                                        resetTop={resetTop}
                                        setResetTop={setResetTop}
                                    />
                                )}
                            </MediaListener>
                        </HasPermissions>
                        <Query query={GET_CARRIERS} variables={{}}>
                            {({ data: dataCarriers, loading: loadingCarriers }) => {
                                return <Loading loading={loadingCarriers}>
                                    <Query
                                        query={GET_ORDERS}
                                        variables={filteredVariables(variables)}
                                        pollInterval={120000}
                                        onCompleted={() => {
                                            get(traceOrdersInitialLoad, 'state') === 2 && traceOrdersInitialLoad.stop();
                                            get(traceOrdersAction, 'state') === 2 && traceOrdersAction.stop();
                                        }}
                                    >
                                        {({ data, loading, networkStatus }) => {
                                            const count = get(data, 'orders.count', 0);
                                            const totalPages = count > 10000 ? 10000 : count;
                                            !loading && setLoadingReportBtn(false);
                                            !loading && setOrdersCount(count);

                                            const paginationProperties = {
                                                defaultPageSize: 100,
                                                pageSize,
                                                onChangePageSize: ({ value }) => {
                                                    const sizeValue = get(value, 'value', 100);
                                                    if (pageSize === 50 && sizeValue === 100) {
                                                        const fullSizePages = totalPages / 100;
                                                        const maxFullSizePages = fullSizePages > parseInt(fullSizePages) ? parseInt(fullSizePages + 1) : parseInt(fullSizePages);
                                                        if (currentPage > fullSizePages) setCurrentPage(maxFullSizePages);
                                                    }
                                                    setPageSize(sizeValue);
                                                },
                                                onChange: value => setCurrentPage(value),
                                                current: currentPage,
                                                total: totalPages,
                                                optionsUp: true
                                            };

                                            return (
                                                <Loading loading={networkStatus === 6 ? false : loading}>
                                                    <If
                                                        condition={size(data)}
                                                        then={(
                                                            <>
                                                                <Row maxHeight='60px'>
                                                                    <MobileWrapper hide showDesktop>
                                                                        <Column align='start' justify='center'>
                                                                            <TableCount count={count} />
                                                                        </Column>
                                                                        <Column>
                                                                            <Pagination {...paginationProperties} />
                                                                        </Column>
                                                                    </MobileWrapper>
                                                                    <MobileWrapper>
                                                                        <Column align='end' justify='center'>
                                                                            <TableCount count={count} />
                                                                        </Column>
                                                                    </MobileWrapper>
                                                                </Row>
                                                                <OrdersTable
                                                                    session={session}
                                                                    pageSize={100}
                                                                    data={matchCarriersAndOrders(get(data, 'orders.results'), get(dataCarriers, 'getCarriers'))}
                                                                    loading={loading}
                                                                    rowSelection={!isEmpty(massiveAction) && {
                                                                        selectedRowKeys: selectedOrders,
                                                                        onSelect: (record, selected, selectedRows) => {
                                                                            onSelectOrderMassiveAction(selectedRows, selected, record);
                                                                        },
                                                                        getCheckboxProps: (record) => {
                                                                            const isExpress = get(record, 'logisticsInfo.selectedSla') === 'Despacho Express';
                                                                            const translationTag = `order_status.${_get(record, 'pickingInfo.status.label', 'pending')}`;
                                                                            return {
                                                                                disabled: get(esDictionary, translationTag) !== 'Pendiente picking' || isExpress
                                                                            };
                                                                        },
                                                                        onSelectAll: (selected, selectedRows) => {
                                                                            onSelectOrderMassiveAction(selectedRows, selected);
                                                                        }
                                                                    }}
                                                                />
                                                                <MobileWrapper>
                                                                    <Pagination {...paginationProperties} />
                                                                </MobileWrapper>
                                                            </>
                                                            )}
                                                        else={(
                                                            <NotFound
                                                                firstTextLine='No se encontraron resultados'
                                                                icon='cross'
                                                                iconBackgroundColor='#eaeaea'
                                                            />
                                                        )}
                                                    />
                                                </Loading>
                                            );
                                        }}
                                    </Query>
                                </Loading>;
                            }}
                        </Query>
                    </FlexContainer>
                    <MobileWrapper>
                        <Modal
                            visible={showMobileFilters}
                            style={{ marginTop: '-25%' }}
                            footer={null} onCancel={() => setShowMobileFilters(false)}
                        >
                            <HasPermissions to={['orders-page:filter&search']}>
                                <LeftFilters
                                    isMobile
                                    userSalesChannel={getSessionSalesChannelById}
                                    defaultShippingETA={params.range ? [moment(params.range[0], 'YYYY-MM-DD HH:mm:ss'), moment(params.range[1], 'YYYY-MM-DD HH:mm:ss')] : [moment(), moment()]}
                                    defaultSla={params.selectedSla}
                                    defaultStatus={params.status}
                                    defaultSalesChannel={params.salesChannel || sessionSalesChannel}
                                    sessionSalesChannel={sessionSalesChannel}
                                    salesChannel={salesChannel}
                                    category={category}
                                    allCategoryOptions={allCategory}
                                    datePickerCheckboxes={datePickerCheckboxes}
                                    onChangeDatePickerCheckbox={(value, index) => onChangeDatePickerCheckbox(value, index)}
                                    onChangeCreationDate={value => {
                                        if (!leftFiltersInitialized) setLeftFiltersInitialized(true);
                                        setCreationDate(value);
                                    }}
                                    onChangeShippingETA={value => setShippingETA(value)}
                                    onChangeSalesChannel={({ value }) => setSalesChannel(value)}
                                    onChangeCategory={({ value }) => setCategory(value)}
                                    selectedSla={selectedSla}
                                    onChangeSelectedSla={value => setSelectedSla(value)}
                                    status={status}
                                    onChangeStatus={value => setStatus(value)}
                                    defaultAtrasado={atrasado}
                                    onChangeAtrasado={setAtrasado}
                                    onChangeOrderType={value => setOrderType(value)}
                                    reseting={reseting}
                                    orderType={orderType}
                                    onReset={onReset}
                                    onSubmit={() => {
                                        onSubmit();
                                        setShowMobileFilters(false);
                                    }}
                                />
                            </HasPermissions>
                        </Modal>
                        <FlexContainer fixedHeight={60}>
                            <FlexContainer
                                fixedHeight={70}
                                position='fixed'
                                backgroundColor='#ffffff'
                                padding={20}
                                style={{ bottom: 0, minWidth: '100%', borderTop: '1px solid #eaeaea' }}
                                zIndex='3'
                            >
                                <Button text='Filtrar por:' onClick={() => setShowMobileFilters(true)} />
                            </FlexContainer>
                        </FlexContainer>
                    </MobileWrapper>
                </Main>
            </Container>
            <DrawerReschedulingMassive opened={opened} setOpened={setOpened} orderData={orderData} selectedOrders={selectedOrders} />
        </HasPermissions>
    );
};

Orders.propTypes = {
    session: object,
    firebasePerformance: object,
    location: object,
    history: object,
    client: object
};

export default withApollo(withRouter(withNavigation(withFirebase(Orders))));
